<template>
  <div class="wrapper" @click.self="handleClose">
    <div class="centered">
      <slot />
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  closeOnClickOutside: {
    type: Boolean,
    default: false,
  },
  handleClose: {
    type: Function,
    default: null,
  },
})

const handleClose = (e) => {
  if (props.closeOnClickOutside && e.target.classList.contains('wrapper')) {
    e.stopPropagation()
    e.preventDefault()
    props.handleClose(null)
  }
}
</script>

<style scoped lang="scss">
.wrapper {
  z-index: 1000;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  transition: opacity 0.25s;
  display: flex;
  align-items: center;
  justify-content: center;

  .centered {
    width: auto;
    height: auto;
    background-color: white;
    border-radius: 4px;
    overflow: hidden;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  }
}

.dialog-enter-from.wrapper,
.dialog-leave-to.wrapper {
  opacity: 0;

  .centered {
    transform: translate(-50%, -50%) scale(0.5);
  }
}
</style>
